export const ErrorPage = () => {
  return <div role="alert">Something went wrong!</div>; // TODO: some basic error page
};
